<!-- 艺术家推荐 -->
<template>
  <div class="home_component news_and_info fd_column">
    <div class="component_title m-b-30">
      <div class="title_mid">
        <div class="title">艺术家推荐</div>
        <div class="subtitle">Artist recommendation</div>
        <div
          class="viewMore_more"
          @click="
           scrollRecord('Home', 'Home');
            linkJump(2, '/ArtistList');
          "
        >
          查看更多
        </div>
      </div>
    </div>
    <div class="component_box longhair">
      <div class="swiper-container swiper" id="longhair_swiper">
        <div class="swiper-wrapper">
          <div
            @mousemove="mloop ? null : showmouse(index)"
            @mouseout="showout"
            class="swiper-slide"
            :class="[
              isActiveIndex === index ? 'transition-start' : 'transition-out',
            ]"
            v-for="(item, index) in listData"
            :key="index"
            @click="
              scrollRecord('Home', 'Home');
              linkJump(1, '/ArtistDetail', { id: item.id });
            "
          >
            <img :src="imgApi + item.avatar" alt="" class="imgLeaving" />
            <div class="longhair_artistName">
              <div>{{ item.artistName }}</div>
              <div></div>
              <!-- {{ item.goodField }} 艺术家擅长领域暂时隐藏，显示的话放在上面的div里 -->
            </div>
          </div>
        </div>
      </div>
      <div @click="slideNext" class="button-next">
        <img v-if="nextClick" src="@/assets/Aboutart/left_active.png" alt="" />
        <img v-else src="@/assets/Aboutart/left.png" alt="" />
      </div>
      <div @click="slidePrev" class="button-prev">
        <img v-if="prevClick" src="@/assets/Aboutart/right_active.png" alt="" />
        <img v-else src="@/assets/Aboutart/right.png" alt="" />
      </div>
    </div>
    <div class="view_more" @click="linkJump(1, '/ArtistList')">
      <div>查看更多</div>
      <img src="@/assets/common/view_more.png" alt="" />
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getList } from "@/api/Home/Notice";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      imgApi: process.env.VUE_APP_BASE_IMAGE,
      swiper: null,
      listData: [],
      isActiveIndex: null,
      activeIndex: 0,
      isDelayedTransitionImg: false,
      nextClick: false,
      prevClick: false,
      windowWidth: null,
      swipersize: null,
      mloop: false,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handleScroll() {
      this.windowWidth = window.innerWidth;
      this.windowWidth > 1024 ? (this.swipersize = 4) : (this.swipersize = 2);
      if (this.windowWidth < 1024) {
        this.mloop = true;
      }
      this.initSwiper();
    },
    slideNext() {
      this.nextClick = true;
      if (this.swiper) {
        this.swiper.slidePrev();
        setTimeout(() => {
          this.prevClick = false;
        }, 100);
      }
      this.prevClick = false;
    },
    slidePrev() {
      this.prevClick = true;
      if (this.swiper) {
        this.swiper.slideNext();
        setTimeout(() => {
          this.nextClick = false;
        }, 100);
      }
    },
    showmouse(index) {
      if (!this.mloop) {
        this.isActiveIndex = index;
        this.activeIndex = index;
      }
    },
    showout() {
      this.isActiveIndex = null;
    },
    initSwiper() {
      setTimeout(() => {
        this.swiper = new Swiper("#longhair_swiper", {
          slidesPerView: this.swipersize,
          spaceBetween: 30,
          loop: this.mloop,
        });
      }, 300);
    },
    async getList() {
      const res = await getList();
      if (res.code === 1) {
        this.listData = res.data;
        this.initSwiper();
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
    this.handleScroll();
    window.addEventListener("resize", this.handleScroll);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {
    window.removeEventListener("resize", this.handleScroll);
  }, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";

.component_box {
  position: relative;
  box-sizing: border-box;
  .normal_flex;
  background-color: transparent;
  border-radius: 6px 6px 6px 6px;
  .pane_box {
    margin-top: 30px;
    width: 100%;
    height: 416px;
    display: flex;
    justify-content: space-between;
    .pane_left,
    .pane_right {
      width: 700px;
      height: 416px;
      border-radius: 6px 6px 6px 6px;
    }
    .pane_right {
      box-sizing: border-box;
      background-color: #fff;
      padding: 30px;
      .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .title {
          width: 460px;

          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #323233;
          line-height: 27px;
        }
        .time {
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #969799;
          line-height: 27px;
        }
      }
    }
  }
  .arrow {
    position: absolute;
    width: 44px;
    height: 44px;
    border: none;
    &.arrow_left {
      left: -84px;
      top: 50%;
      transform: translateY(-50%);
    }
    &.arrow_right {
      right: -84px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.news_and_info {
  .component_box {
    position: relative;
    width: 100%;
    justify-content: space-between;
  }
  .swiper-container {
    width: 100%;
    height: 1.9792rem;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: transparent;
    width: 1.7552rem;
    height: 1.9792rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0.0521rem;
      transition: transform 0.3s ease;
    }
    .longhair_artistName {
      margin-top: 0.3125rem;
      transition: margin-top 0.4s ease;
      :first-child {
        font-family: Source-Medium;
        font-weight: 500;
        font-size: 0.125rem;
        color: #333333;
        line-height: 0.1458rem;
        text-align: center;
        margin-bottom: 0.0208rem;
        margin-top: 0.0521rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
      }
      :last-child {
        font-family: Source-Regular;
        font-weight: 400;
        font-size: 0.0938rem;
        color: #666666;
        line-height: 0.1094rem;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
      }
    }
  }
  .transition-start img {
    transform: scale(0.8);
    transform-origin: top;
  }
  .transition-out img {
    transform: scale(1);
    transform-origin: top;
  }
  .transition-start .longhair_artistName {
    margin-top: -0.3542rem;
  }
  .button-next {
    cursor: pointer;
    position: absolute;
    left: -0.5208rem;
    top: 0.875rem;
    img {
      width: 0.2292rem;
      height: 0.2292rem;
    }
  }
  .button-prev {
    cursor: pointer;
    position: absolute;
    right: -0.5208rem;
    top: 0.875rem;
    img {
      width: 0.2292rem;
      height: 0.2292rem;
    }
  }
}
.project_item {
  position: relative;
  overflow: hidden;
  border-radius: 6px 6px 6px 6px;
  width: 700px;
  height: 416px;
  box-sizing: border-box;
  .normal_flex;
  .fd_column;
  justify-content: space-between;

  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #323233;
  line-height: 27px;
  img {
    width: 100%;
    height: 100%;
  }
  .title {
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 70px;
    padding: 0 30px;
    background: rgba(0, 0, 0, 0.43);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 27px;
  }
}
@media screen and (max-width: 1024px) {
  .news_and_info .button-prev {
    display: none;
  }
  .news_and_info .button-next {
    display: none;
  }
  .news_and_info .swiper-slide {
    width: 4.48rem;
    height: 5.0133rem;
    border-radius: 8px 8px 8px 8px;
  }
  .news_and_info .swiper-container {
    height: 100%;
  }
  .view_more {
    display: none;
  }
  .swiper {
    overflow: inherit;
  }
  .longhair_artistName {
    margin-top: 0.4rem;
    :first-child {
      font-size: 0.3467rem !important;
      line-height: 0.4rem !important;
    }
    :last-child {
      font-size: 0.2933rem !important;
      line-height: 0.3467rem !important;
      margin-top: 0.0533rem;
    }
  }
  .home_component {
    padding-top: 5.3333rem !important;
    padding-bottom: 2.3333rem !important;
  }
}
@media screen and (min-width: 1024px) {
  .viewMore_more {
    display: none;
  }
}
</style>
<style lang="less"></style>
